import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

export interface ITooltipProps {
  text: string;
  tooltipText: string;
  className?: string;
}

const StyledTooltipContainer = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    fontSize: 16,
  },
}));

export default function TableTooltip({ text, tooltipText, className }: ITooltipProps) {
  return (
    <StyledTooltipContainer title={tooltipText} enterDelay={100} arrow>
      <Typography className={className ?? "table-tooltip"} variant="inherit">{text}</Typography>
    </StyledTooltipContainer>
  );
};




